export const PAYEVER_SDK = 'payever-sdk';
export const PAYEVER_WIDGET_CLASS = 'payever-widget-finexp';
export const PAYEVER_LOAD_TIMEOUT = 50;
